import React, { useState, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import JSZip from 'jszip'

import CloseIcon from '@material-ui/icons/Close'
import FolderIcon from '@material-ui/icons/Folder'
import PublishIcon from '@material-ui/icons/Publish'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'

import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

import Folder from '../../../../../assets/folder_blue.png'

const converter = require('@tmcw/togeojson')
const DOMParser = require('xmldom').DOMParser

import '../filesMenu.css'

const useStyles = makeStyles((theme) => ({
  loading: {
    color: '#a65e44',
    width: '30px !important',
    height: '30px !important',
    alignSelf: 'center',
    margin: 'auto',
    marginTop: '10px',
  },
  root: {
    color: 'rgba(166, 94, 68, 1) !important',
  },
  kmlDel: {
    color: '#bf0000',
  },
  importBtn: {
    backgroundColor: '#03a9f4',
    boxShadow: 'none',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#01579b',
      borderColor: '#01579b',
      boxShadow: 'none',
    },
  },
  slider: {
    color: '#c1c1c1',
    width: '50px',
    marginLeft: '13px',
    padding: '7px 0',
  },
}))

function ImportModal(props) {
  const classes = useStyles()

  const { acceptedFiles, getRootProps, open, getInputProps, inputRef } = useDropzone({
    noClick: true,
    accept: {
      'application/*': ['.kml', '.geojson', '.kmz'],
      //   'application/*': ['.json'],
      //   'application/*': ['.geojson'],
    },
    maxFiles: 5,
    // maxSize: 41943040,
    onDrop: (files) => onDrop(files),
    onDropRejected: (file) => onDropRejected(file),
  })

  const [file, setFile] = useState([])
  const [dzDisplay, setDZDisplay] = useState('block')
  const [alertText, setAlertText] = useState([])
  const [added, setAdded] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    file.length === 0 ? setDZDisplay('block') : null
  }, [file])

  useEffect(() => {
    props.addFeatures(added)
    // console.log(added)
  }, [added])

  const errorMessages = (data) => {
    var string = ':'
    for (var i = 0; i < data.length; i++) {
      string += ' ' + data[i].code
    }
    return string
  }

  const onDrop = (data) => {
    if (file.length >= 5) {
      setAlertText([{ file: 'Error', errors: "You can't upload more than 5 files" }])
    } else {
      setDZDisplay('none')
      let test = file
      setFile(test.concat(data))
      setAlertText([])
    }
  }

  const onDropRejected = (data) => {
    if (file.length === 0) {
      setDZDisplay('block')
    }
    const errors = []
    data.map((obj) => {
      errors.push({ file: obj.file.name, errors: errorMessages(obj.errors) })
    })
    setAlertText(errors)
  }

  const drop = (name) => {
    setFile(file.filter((f) => f.name !== name))
  }

  const formatGeometries = (feature) => {
    const test = []
    feature.geometry.geometries.map((data) => {
      test.push({
        geometry: data,
        properties: feature.properties,
        type: 'Feature',
      })
    })
    return test
  }

  const formatProperties = (id, properties) => {
    const newProps = properties
    newProps.id = id.split('.')[0]
    newProps.show = 1
    newProps.fillColor && !Array.isArray(newProps.fillColor)
      ? (newProps.fillColor = newProps.fillColor.split(',').map((val) => parseFloat(val)))
      : null
    newProps.lineColor && !Array.isArray(newProps.lineColor)
      ? (newProps.lineColor = newProps.lineColor.split(',').map((val) => parseFloat(val)))
      : null
    newProps['stroke-width'] ? (newProps['stroke-width'] = parseFloat(newProps['stroke-width'])) : null
    newProps['stroke-opacity'] ? (newProps['stroke-opacity'] = parseFloat(newProps['stroke-opacity'])) : null
    newProps['fill-opacity'] ? (newProps['fill-opacity'] = parseFloat(newProps['fill-opacity'])) : null
    newProps.opacity ? (newProps.opacity = parseFloat(newProps.opacity)) : null
    newProps.colorCode ? (newProps.colorCode = JSON.parse(newProps.colorCode)) : null
    newProps.colorCodeB ? (newProps.colorCodeB = JSON.parse(newProps.colorCodeB)) : null
    newProps.dottedLine && !Array.isArray(newProps.dottedLine)
      ? (newProps.dottedLine = JSON.parse(newProps.dottedLine))
      : null
    // console.log(newProps.dottedLine)
    return newProps
  }

  // const upload = () => {
  //   if (file != undefined) {
  //     setLoading(true)
  //     file.map((data, i) => {
  //       // if(data.name.includes('.kmz')){
  //       //   transformKmz(data)
  //       // }else{
  //       let reader = new FileReader()
  //       reader.readAsText(data)
  //       const transformed = []
  //       reader.onload = () => {
  //         let geojson = ''
  //         if(data.name.includes('.kml')){geojson = converter.kml(new DOMParser().parseFromString(reader.result))}
  //         if(data.name.includes('.kmz')){transformKmz(data)}
  //         if(data.name.includes('.geojson')){geojson = JSON.parse(reader.result)}
  //         geojson.features.map((ftr) => {
  //           if (
  //             ftr.geometry.type === 'GeometryCollection' ||
  //             ftr.geometry.type === 'MultiPoint' ||
  //             ftr.geometry.type === 'MultiLineString' ||
  //             ftr.geometry.type === 'MultiPolygon'
  //           ) {
  //             ftr.properties = formatProperties(data.name, ftr.properties)
  //             transformed.push(...formatGeometries(ftr))
  //           } else {
  //             ftr.properties = formatProperties(data.name, ftr.properties)
  //           }
  //         })
  //         setAdded(geojson.features.concat(transformed))
  //         props.setProjects((prevState) => {
  //           return [...prevState, { projectName: data.name.split('.')[0], visible: true, active: false, height: true, s3:false }]
  //         })
  //         reader.onerror = () => console.log(reader.error)
  //         reader.onloadend = () => {
  //           if (i === file.length - 1) {
  //             setTimeout(() => {
  //               setLoading(false)
  //               props.setImportModal(false)
  //             }, 2000)
  //             // props.setImportModal(false)
  //           }
  //         }
  //       }
  //     // }

  //   })
  //   } else if (file === undefined) {
  //   }
  // }

  const upload = async () => {
    if (file != undefined) {
      setLoading(true)

      await Promise.all(
        file.map(async (file) => {
          // Realiza una operación asincrónica para cada elemento del arreglo
          let geojson = ''
          let transformed = []
          if (file.name.includes('.kmz')) {
            geojson = await transformKmz(file)
          }
          if (file.name.includes('.kml')) {
            geojson = await transformKml(file)
          }
          if (file.name.includes('.geojson')) {
            geojson = await transformJson(file)
          }
          //if(file.name.includes('.geojson')){}
          geojson.features.map((ftr) => {
            if (
              ftr.geometry.type === 'GeometryCollection' ||
              ftr.geometry.type === 'MultiPoint' ||
              ftr.geometry.type === 'MultiLineString' ||
              ftr.geometry.type === 'MultiPolygon'
            ) {
              ftr.properties = formatProperties(file.name, ftr.properties)
              !file.name.includes('.geojson') ? transformed.push(...formatGeometries(ftr)) : null
            } else {
              ftr.properties = formatProperties(file.name, ftr.properties)
            }
          })
          setAdded(geojson.features.concat(transformed))
          props.setProjects((prevState) => {
            return [
              ...prevState,
              { projectName: file.name.split('.')[0], visible: true, active: false, height: true, s3: false },
            ]
          })
        }),
      )

      setTimeout(() => {
        setLoading(false)
        props.setImportModal(false)
      }, 2000)
    } else if (file === undefined) {
    }
  }

  const transformKmz = async (kmzFile) => {
    try {
      const zip = new JSZip()
      const zipData = await zip.loadAsync(kmzFile)
      const kmlFile = Object.keys(zipData.files).find((fileName) => fileName.endsWith('.kml'))

      const kmlContent = await zipData.files[kmlFile].async('string')
      const geojson = converter.kml(new DOMParser().parseFromString(kmlContent))
      return new Promise((resolve) => {
        resolve(geojson)
      })
    } catch (error) {
      console.error('Error al leer el archivo KMZ:', error)
    }
  }

  const transformKml = async (data) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = (event) => {
        const fileContent = converter.kml(new DOMParser().parseFromString(event.target.result))
        // console.log(fileContent)
        resolve(fileContent)
      }

      reader.onerror = (event) => {
        reject(event.target.error)
      }

      reader.readAsText(data)
    })
  }

  const transformJson = async (data) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = (event) => {
        const fileContent = JSON.parse(event.target.result)
        // console.log(fileContent)
        resolve(fileContent)
      }

      reader.onerror = (event) => {
        reject(event.target.error)
      }

      reader.readAsText(data)
    })
  }

  const format = (val) => {
    if (val < 1048546) return new Intl.NumberFormat('en').format(val) + ' Bytes'
    if (val >= 1048546) return new Intl.NumberFormat('en').format(Math.floor(val / 1048576)) + ' MB'
  }

  const files = file.map((file) => (
    <div style={{ display: 'flex', fontSize: '15px', height: '35px' }}>
      <InsertDriveFileIcon style={{ color: '#03a9f4', alignSelf: 'center', marginRight: '5px' }} />
      <p className="file-tag" key={file.name}>
        {' '}
        {file.name}
      </p>
      <p style={{ marginLeft: '14px', margin: '0px', alignSelf: 'center' }}>
        <b>| {format(file.size)}</b>
      </p>
      <CloseIcon
        style={{ color: '#03a9f4', alignSelf: 'center', marginLeft: '5px', cursor: 'pointer' }}
        onClick={() => drop(file.name)}
      />
    </div>
  ))

  const alerts = alertText.map((err) => (
    <div style={{ display: 'flex', marginBottom: '5px' }}>
      <Alert severity="error">
        <b>{err.file}</b> {err.errors}
      </Alert>
    </div>
  ))

  return (
    <div className="modal-container" style={{ margin: 'auto', alignSelf: 'center' }}>
      <IconButton
        // variant="contained"
        // className={classes.modalBtn}
        onClick={() => {
          props.setImportModal(false)
        }}
        size="small"
        style={{ position: 'absolute', top: '0px', right: '0px', borderRadius: '0 0 0 5px' }}
      >
        <CloseIcon />
      </IconButton>
      <h3 style={{ marginTop: '0px' }}>Select your files</h3>

      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <img src={Folder} style={{ height: '70px', marginTop: '0px', width: '70px', display: `${dzDisplay}` }} />
        <p style={{ fontSize: '14px', display: `${dzDisplay}` }}>
          Drag and drop your KML files to convert it into a visible layer on the map, or click the select files button.
        </p>
        <div>{files}</div>
      </div>
      <div className="modal-alert-container">
        {alerts}
        {loading ? (
          <div style={{ height: '40px', width: '80px', margin: 'auto', display: 'grid' }}>
            <CircularProgress style={{ height: '30px', width: '30px', margin: 'auto', color: '#03a9f4' }} />
            <h5 style={{ width: 'fit-content', marginTop: '5px', color: '#03a9f4' }}>Importing Files</h5>
          </div>
        ) : null}
      </div>

      <div className="modal-btn-container">
        <Button
          variant="contained"
          className={classes.importBtn}
          onClick={open}
          size="small"
          component="span"
          style={{ margin: 'auto', width: '135px' }}
          startIcon={<FolderIcon />}
        >
          Select Files
        </Button>

        <Button
          variant="contained"
          className={classes.importBtn}
          onClick={() => {
            if (file.length > 0) {
              upload()
              // setOpenModal(false)
              // setLoading(true)
            }
          }}
          size="small"
          component="span"
          style={{ margin: 'auto', width: '135px' }}
          startIcon={<PublishIcon />}
        >
          Upload
        </Button>
      </div>

      <div className="modal-footer">
        <p className="modal-footer-txt">
          <b>File Uploader Tool upload limits:</b> 40 MB per file | Maximum of 5 files | Accepts <b>kml</b>, <b>kmz</b>{' '}
          and <b>geojson</b> files
        </p>
      </div>
    </div>
  )
}

export default ImportModal
